import { ItemType, OptionActions, OptionKey, OptionsActionTypes, OptionsState, VisTypes } from "./types";

// Initial state
export const initialState: OptionsState = {
  options: {
    [OptionKey.HideSensitiveData]: {
      type: ItemType.toggleItem,
      view: [VisTypes.All],
      value: false,
    },
    [OptionKey.ShowFolderHierarchy]: {
      type: ItemType.toggleItem,
      view: [VisTypes.Files],
      value: true,
    },
    [OptionKey.Grouping]: {
      type: ItemType.toggleItem,
      value: true,
      view: [VisTypes.Files],
    },
    [OptionKey.ShowImages]: {
      type: ItemType.toggleItem,
      view: [VisTypes.Files],
      value: false,
    },
    [OptionKey.ElementSize]: {
      type: ItemType.selectorItem,
      view: [VisTypes.Files],
      value: "uncompressed",
      options: ["uncompressed", "length", "evenly"],
    },
    [OptionKey.MultipleViews]: {
      type: ItemType.toggleItem,
      view: [VisTypes.Sunburst, VisTypes.ContactGraph, VisTypes.Piechart, VisTypes.Timeline, VisTypes.Barchart],
      value: false,
    },
    [OptionKey.ColorScheme]: {
      type: ItemType.selectorItem,
      view: [VisTypes.Timeline],
      value: "category",
      options: ["category", "subcategory", "provider", "location"],
    },
    [OptionKey.LinearLayout]: {
      type: ItemType.toggleItem,
      view: [VisTypes.Grid],
      value: false,
    },
    [OptionKey.ColumnCount]: {
      type: ItemType.numberItem,
      view: [VisTypes.Grid],
      value: 3,
    },
  },
  currentVis: VisTypes.Files,
  navSidebarOpen: true,
  configSidebarOpen: false,
  searchString: "",
  version: 6,
};

// The reducer function
export function optionsReducer(state = initialState, action: OptionActions): OptionsState {
  switch (action.type) {
    case OptionsActionTypes.SELECT: {
      const { id, value } = action.payload;
      return {
        ...state,
        options: { ...state.options, [id]: { ...state.options[id], value } },
      };
    }
    case OptionsActionTypes.SWITCH_VIS: {
      const { label } = action.payload;

      return {
        ...state,
        currentVis: label,
      };
    }
    case OptionsActionTypes.SEARCH: {
      // TODO: should filter the data in the store directly
      const { label } = action.payload;
      return {
        ...state,
        searchString: label,
      };
    }
    case OptionsActionTypes.SIDEBAR: {
      const { label } = action.payload;
      return {
        ...state,
        navSidebarOpen: label !== undefined ? label : !state.navSidebarOpen,
      };
    }
    case OptionsActionTypes.CONFIG: {
      const { label } = action.payload;
      return {
        ...state,
        configSidebarOpen: label !== undefined ? label : !state.configSidebarOpen,
      };
    }
    case OptionsActionTypes.TOGGLE: {
      return initialState;
    }

    default: {
      return state;
    }
  }
}
